import React from 'react';
import './GoalIcon.css';

interface GoalIconProps {
  size?: number;
  team?: 'black' | 'white';
}

const GoalIcon: React.FC<GoalIconProps> = ({ size = 20, team = 'black' }) => {
  const iconPath = team === 'black' 
    ? '/icons/gol-icon-black.png.png'
    : '/icons/gol-icon-white.png.png';

  return (
    <img 
      src={iconPath} 
      alt="Gol" 
      className="goal-icon"
      style={{ width: size, height: size }}
      onError={(e) => {
        // Takıma özel ikon yüklenemezse varsayılan ikonu göster
        e.currentTarget.src = '/icons/gol-icon.png.png';
      }}
    />
  );
};

export default GoalIcon;

